// @ts-nocheck 
// @ts-nocheck
import { Instance, types } from 'mobx-state-tree';
import { MenuHierarchyRecordModelBase } from './MenuHierarchyRecordModel.base';

/* The TypeScript type of an instance of MenuHierarchyRecordModel */
export interface MenuHierarchyRecordModelType
  extends Instance<typeof MenuHierarchyRecordModel.Type> {}

/* A graphql query fragment builders for MenuHierarchyRecordModel */
export {
  selectFromMenuHierarchyRecord,
  menuHierarchyRecordModelPrimitives,
  MenuHierarchyRecordModelSelector,
} from './MenuHierarchyRecordModel.base';

/**
 * MenuHierarchyRecordModel
 *
 * Record of type Menu Hierarchy (menu_hierarchy)
 */
export const MenuHierarchyRecordModel = MenuHierarchyRecordModelBase.props({
  hierarchySlug: types.union(types.undefined, types.null, types.string),
  isAll: false,
}).actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self));
  },
}));
